/**
 * Content type IDs for bylaws article content. Must match document_content_types table.
 * List: bullet list blocks. PARAGRAPH_CONTENT_TYPE_ID: text blocks shown in the UI as "Section" under an "Article".
 */
export const LIST_CONTENT_TYPE_ID = 'c1e257bc8c674ae28a7b2085518aea9e';
/** Text block content type (stored as paragraph) — must exist in document_content_types. */
export const PARAGRAPH_CONTENT_TYPE_ID = '60308536096c4ce088bee75af7ae8ae2';

export function createNewSection(order: number): {
  id: string;
  title: string;
  order: number;
  content: Array<{
    id: string;
    paragraph: string;
    order: number;
    title: string;
    content_type_id: string;
    list: Array<{ id: string; content: string; order: number }>;
  }>;
} {
  return {
    id: '',
    title: 'New Article',
    order,
    content: [],
  };
}

export function createNewParagraphContent(
  order: number,
  paragraphContentTypeId: string
) {
  return {
    id: '',
    title: '',
    paragraph: '',
    order,
    content_type_id: paragraphContentTypeId,
    list: [],
  };
}

export function createNewListContent(order: number, listContentTypeId: string) {
  return {
    id: '',
    title: '',
    paragraph: '',
    order,
    content_type_id: listContentTypeId,
    list: [],
  };
}

export function createNewListItem(order: number): {
  id: string;
  content: string;
  order: number;
} {
  return {
    id: '',
    content: '',
    order,
  };
}

/** Normalize order fields to 0, 1, 2, ... for articles, content blocks, and list items. */
export function normalizeOrders<T extends { order: number }>(items: T[]): T[] {
  return items.map((item, i) => ({ ...item, order: i }));
}
